import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const CenteredTooltip = styled((props: TooltipProps) => (
  <Tooltip {...props} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    textAlign: 'center',
  },
}));

export default CenteredTooltip;
